@use '../../design-tokens/border-radius/border-radius' as *;
@use '../../design-tokens/typography/typography' as *;

$transition-easing: var(--duration, 400ms) cubic-bezier(0.75, 0.02, 0.5, 1);

@layer design-system {
  .titleContainer {
    color: var(--text-primary);
    @include typography-v2-body-base;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    margin: 0;
    gap: 4px;

    &.expandable:hover {
      cursor: pointer;
    }
  }

  .titleContent {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    & svg {
      margin-bottom: 3px;
    }
  }

  .rightAlignedItems {
    display: flex;
    gap: 6px;
    flex-direction: row;
    align-items: center;
    @include typography-v2-body-base;
  }

  .iconStyled {
    flex-shrink: 0;
    transition: transform 0.4s cubic-bezier(0.75, 0.02, 0.5, 1);
    display: block;
    max-width: 100%;

    &.withDefaultIcon {
      transform: rotate(90deg);

      &.expanded {
        transform: rotate(-90deg);
      }
    }
  }

  .content {
    padding: 0 10px 8px;
    @include typography-v2-body-base;
    overflow: hidden;
    color: var(--text-default);
  }

  .transitionWrapper {
    overflow: hidden;
    transition: height $transition-easing;
  }

  .autoHeightTransition {
    display: grid;
    transition: grid-template-rows $transition-easing;

    .content {
      min-height: 0;
    }
  }

  .accordionItem {
    margin-bottom: 20px;
    @include border-radius-r2;

    &.hideIcon {
      .iconStyled {
        display: none;
      }

      .content {
        padding-left: 10px;
      }
    }
  }

  .accordion {
    .accordionItem {
      background-color: transparent;

      &:hover {
        background-color: var(--surface-hover);
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &.withBackground .accordionItem {
      background-color: var(--surface-default);
    }

    &.secondary {
      .accordionItem {
        &:not(:first-child, :last-child) {
          border-top: 0;
          border-radius: 0;
        }

        &:first-child {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }

        &:last-child {
          border-top: 0;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }

        margin-bottom: 0;
        background-color: var(--background-default);
        border: 1px solid var(--border-soft);

        .titleContent {
          color: var(--text-default);
        }

        .content {
          @include typography-v2-body-sm;
          color: var(--text-soft);
          padding: 0 40px 13px;
        }
      }
    }
  }
}
